import { render, staticRenderFns } from "./GameReplayMobileView.vue?vue&type=template&id=52c1232d&scoped=true"
import script from "./GameReplayMobileView.vue?vue&type=script&lang=js"
export * from "./GameReplayMobileView.vue?vue&type=script&lang=js"
import style0 from "./GameReplayMobileView.vue?vue&type=style&index=0&id=52c1232d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c1232d",
  null
  
)

export default component.exports